
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {TransactionProps} from "types/props-obj/TransactionProps";

const initialState: TransactionProps = {
  apiEndPoint: "transaction",
  pageLimit: 5,
  pageNumber: 1,
  isOpen: false,
  list: [],
  item: null,
  error: null,
  alertPopup: false
};

const transaction = createSlice({
  name: initialState.apiEndPoint,
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload.error;
    },
    setPageNumber(state, action) {
      state.pageNumber = action.payload;
    },
    setPageLimit(state, action) {
      state.pageLimit = action.payload;
    },
    // get all Item list
    getList(state, action) {
      state.list.push(action.payload);
      state.list = state.list.filter((liste) => liste.id !== 0);
    },
    alertPopupToggle(state, action) {
      console.log(action.payload);
      
      state.alertPopup = action.payload.alertPopup;
    },
    openToggle(state, action) {

      state.isOpen = action.payload.isOpen;
    },
    // get Item details
    setItem(state, action) {
      state.item = action.payload;
    },

    // GET Items
    setItemsSuccess(state, action) {
      state.list = action.payload.data;
      state.current_page=action.payload.current_page;
      state.last_page=action.payload.last_page;
      state.total=action.payload.total
    },

    // ADD Item
    addItemSuccess(state, action) {
      state.list = [...state.list,action.payload];
    },

    // EDIT Item
    editItemSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
      state.item=action.payload;
      state.list[foundIndex] = action.payload;
    },

    deleteItemSuccess(state, action) {
      state.list = state.list.filter((item) => item.id !== action.payload);
    },



    setApiEndPoint(state, action) {
      state.apiEndPoint = action.payload;
    },
    makeListEmpty(state) {
      state.list = [];
    },

  }
});


export default transaction.reducer;

function getApiEndPoint(){
  return store.getState().transaction.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setPageLimit,setApiEndPoint ,makeListEmpty} = transaction.actions;
export function getList(params:any={}) {
  return async () => {
    try {
      const response = await axios.get(getApiEndPoint(),{params:params});
      dispatch(transaction.actions.setItemsSuccess(response.data));
    } catch (error) {
      dispatch(transaction.actions.hasError(error));
    }
  };
}

export function getItem(id: number | undefined) {
  return async () => {
    try {
      const response = await axios.get([getApiEndPoint(),  id].join('/'));
      dispatch(transaction.actions.setItem(response.data));
    } catch (error) {
      dispatch(transaction.actions.hasError(error));
    }
  };
}

export function addItem(ls:any) {
  return async () => {
    try {
      const response = await axios.post(getApiEndPoint(), ls);
      dispatch(transaction.actions.addItemSuccess(response.data));
    } catch (error) {
      dispatch(transaction.actions.hasError(error));
    }
  };
}

export function editItem(id: number | undefined,ls: any) {
  return async () => {
    try {
      const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
      dispatch(transaction.actions.editItemSuccess(response.data));
    } catch (error) {
      dispatch(transaction.actions.hasError(error));
    }
  };
}

export function deleteItem(id: number | undefined) {
  return async () => {
    try {
      await axios.delete([getApiEndPoint(),  id].join('/'));
      dispatch(transaction.actions.deleteItemSuccess(id));
    } catch (error) {
      dispatch(transaction.actions.hasError(error));
    }
  };
}